'use strict';

exports.__esModule = true;
exports.setItem = setItem;
exports.getItem = getItem;
var namespace = 'searchWidget';

function setItem(key, value) {
    localStorage.setItem(namespace + key, typeof value !== 'string' ? JSON.stringify(value) : value);
}

function getItem(key) {
    try {
        return JSON.parse(localStorage.getItem(namespace + key));
    } catch (e) {
        return localStorage.getItem(namespace + key);
    }
}